import React from "react";
export default function MobileSearchTrigger({ onOpen }) {
    return (<div className="search-toggle bg-[#EBECEF] rounded-full cursor-pointer" role="button" aria-label="Wyszukaj" onClick={onOpen}>
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <path id="icons8-search" d="M18.391,9a9.391,9.391,0,1,0,5.722,16.821l6.825,6.825a1.208,1.208,0,0,0,1.708-1.708l-6.825-6.825A9.375,9.375,0,0,0,18.391,9Zm0,2.087a7.3,7.3,0,1,1-7.3,7.3A7.313,7.313,0,0,1,18.391,11.087Z" transform="scale(0.8) translate(3.5 2.5)" fill="currentColor"/>
      </svg>
    </div>);
}
